module.exports = __webpack_public_path__ + "img/outline.9a8e8597.svg";